const en = {
  " · 만료됨": " · Expired",
  "% · 하위에이전트": "% · Sub-agents",
  "%) 중 몇 %를 하위에게 분배하시겠습니까?": "%) do you want to allocate to the child?",
  "(password 있음)": "(password set)",
  "(링크 없음)": "(no link)",
  "(본문 없음)": "(no content)",
  "(본인/직속 하위 에이전트의": "(Shows accumulated values by color for yourself/direct sub-agents",
  "(없음)": "(none)",
  "(여기 클릭하면 새 공지 모달 오픈)": "(Click here to open the new notice modal)",
  "(이름없음)": "(unnamed)",
  "(자동)": "(auto)",
  "(제목 없음)": "(no title)",
  "* index를 바꾼 뒤": "* After changing the index,",
  "* 무한 모드일 때 UI상 “30일마다 갱신”로 표시용": "* In infinite mode, shown in the UI as “renews every 30 days”",
  "* 예: 상위 50% 중": "* Example: of the parent 50%,",
  "* 이 설정은 인포카드 내부 카운트다운 기준입니다. 위 시간 설정은 로비 노출 기간만 제어합니다.": "* This setting controls the countdown inside the info card. The time settings above only control the lobby exposure period.",
  "* 이 스타일은 인포카드의 text 요소에만 적용됩니다. 타이머/아이콘은 기존 스타일을 유지합니다.": "* This style only applies to text elements in the info card. Timers/icons keep their existing style.",
  "* 이 시간에 “유효한(display_sets.time)” 그룹만 아래 목록에 표시": "* Only groups valid at this time (display_sets.time) are shown below.",
  "* 저장은 UTC로 들어가고, 화면은 로컬 시간으로 입력/표시됨": "* Saved as UTC; entered/displayed as local time on screen.",
  "* 필요할 때만 추가하면 됨": "* Add only when needed.",
  "* 현재 기준시간 주변(±15~45일)에 기간(range) 설정된 DisplaySet이 없습니다.": "* No DisplaySet with a range period exists around the current reference time (±15–45 days).",
  "+ 공지 작성": "+ Create Notice",
  "+ 광고 등록": "+ Add Ad",
  "+ 새 공지 작성": "+ New Notice",
  "+ 새 광고 등록": "+ New Ad",
  "+ 아이콘(업로드)": "+ Icon (Upload)",
  "+ 이미지": "+ Image",
  "+ 인포 버튼 추가": "+ Add Info Button",
  "+ 인포카드 추가": "+ Add Info Card",
  "+ 타이머(표시여부)": "+ Timer (Visibility)",
  "+ 텍스트": "+ Text",
  "- PENDING 는 저장만 되고 노출되지 않음": "- PENDING is saved only and not displayed.",
  "- SCHEDULED 는 startAt 이후 자동 노출": "- SCHEDULED is displayed automatically after startAt.",
  "- endAt 이 지나면 자동 만료": "- Automatically expires after endAt.",
  "/community/notice/1 또는 https://...": "/community/notice/1 or https://...",
  "/notice/123 또는 https://...": "/notice/123 or https://...",
  "0 이상 숫자를 입력하세요.": "Enter a number greater than or equal to 0.",
  "0보다 큰 금액을 입력하세요.": "Enter an amount greater than 0.",
  "0보다 큰 숫자만 가능": "Only numbers greater than 0 are allowed.",
  "24시간 반복": "Repeat every 24 hours",
  "2차 비밀번호(선택)": "Secondary Password (Optional)",
  "Country 필터": "Country Filter",
  "DB/API 기반 에이전트 유료 업로드 관리": "DB/API-based paid agent upload management",
  "Device 필터": "Device Filter",
  "DisplaySet 날짜 필터(1일 단위)": "DisplaySet Date Filter (1-day unit)",
  "Due Date 지정": "Set Due Date",
  "Due Date(관리자 로컬 시간)": "Due Date (Admin Local Time)",
  "Due Date를 올바른 날짜/시간으로 입력해야 합니다.": "Enter a valid due date/time.",
  "Due Date를 입력해야 합니다.": "Due date is required.",
  "HTML 저장 없이 텍스트/이미지 블록만 저장합니다.": "Only text/image blocks are saved without storing HTML.",
  "RUN 생성: 미션 총 베팅금(target_total_bet) 입력": "Create RUN: Enter mission total bet (target_total_bet)",
  "RUN 생성: 테이블 미션 총 베팅금(target_total_bet) 입력": "Create RUN: Enter table mission total bet (target_total_bet)",
  "Rake % (수수료율)": "Rake % (Fee Rate)",
  "SB/BB는 0보다 큰 숫자이며 소수점은 최대 2자리까지 입력할 수 있습니다. 예: 0.25 / 0.50": "SB/BB must be numbers greater than 0, with up to 2 decimal places. Example: 0.25 / 0.50",
  "agent_share는 0~1 사이 숫자만 가능 (예: 0.2)": "agent_share must be a number between 0 and 1 (e.g., 0.2).",
  "endAt (종료, 선택)": "endAt (End, Optional)",
  "endAt은 startAt보다 늦어야 해.": "endAt must be later than startAt.",
  "fee_percent (선택, %)": "fee_percent (Optional, %)",
  "fee_percent(유저)": "fee_percent (User)",
  "index(선택)": "index (Optional)",
  "message는 빈값이 될 수 없습니다.": "Message cannot be empty.",
  "message는 필수입니다.": "Message is required.",
  "onCredit 콜백이 연결되어 있지 않습니다.": "onCredit callback is not connected.",
  "onDebit 콜백이 연결되어 있지 않습니다.": "onDebit callback is not connected.",
  "reserve_time_utc(표시:로컬)": "reserve_time_utc (Display: Local)",
  "reserve_time_utc가 지난 waiting들을 running으로 전환": "Move waiting items past reserve_time_utc to running.",
  "startAt (시작)": "startAt (Start)",
  "status(선택)": "status (Optional)",
  "superadmin 전용 UI (admin-server / DB 저장)": "Superadmin-only UI (admin-server / DB storage)",
  "tick 실패": "Tick failed",
  "· 서버에서 카테고리/상태/비용/권한을 다시 검증합니다.": "· The server revalidates category/status/cost/permission.",
  "· 소속유저": "· Assigned Users",
  "※ 이미지는 admin server 의": "※ Images are stored in the admin server's ",
  "※ 입력이 없으면 0%로 처리됩니다.": "※ If empty, it is treated as 0%.",
  "※ 입력이 없으면 0.00%로 처리됩니다.": "※ If empty, it is treated as 0.00%.",
  "※ 현재 저장은 admin-server API를 통해 DB에 반영됨.": "※ Current saves are reflected in DB through the admin-server API.",
  "→ 하위는": "→ Child receives",
  "⚠️ 권한이 없습니다": "⚠️ You do not have permission",
  "같은 area라도 device/country가 다르면 각각 별도 row로 저장돼.": "Even with the same area, different device/country combinations are saved as separate rows.",
  "개": "items",
  "개 · 남은 수량": "items · Remaining Qty",
  "갱신 주기(일)": "Renewal Cycle (days)",
  "갱신 중": "Refreshing",
  "건": "records",
  "검색": "Search",
  "검색 (id / user_code / nickname / 메모)": "Search (id / user_code / nickname / memo)",
  "검색: 이름/링크/국가": "Search: name/link/country",
  "검색: 제목/본문/작성자": "Search: title/content/writer",
  "검색어를 입력하세요": "Enter a search term",
  "게시": "Published",
  "게시 상태": "Publish Status",
  "게시 중": "Publishing",
  "게시일:": "Published At:",
  "결제 영역": "Payment Area",
  "결제 옵션": "Payment Options",
  "결제 옵션 추가": "Add Payment Option",
  "결제 완료": "Payment Complete",
  "결제 항목": "Payment Item",
  "결제 항목 금액은 0보다 큰 정수여야 합니다.": "Payment item amount must be an integer greater than 0.",
  "결제 항목 수량은 0 이상 정수여야 합니다.": "Payment item quantity must be an integer greater than or equal to 0.",
  "결제 항목 수량은 이미 판매된 수량보다 작게 수정할 수 없습니다.": "Payment item quantity cannot be set lower than the quantity already sold.",
  "결제 항목명을 입력하세요.": "Enter the payment item name.",
  "결제관리": "Payment Management",
  "경로": "Path",
  "계정의 정보를 수정합니다.": "Edit account information.",
  "공지 관리": "Notice Management",
  "공지 목록 불러오는 중...": "Loading notice list...",
  "공지 본문": "Notice Body",
  "공지 수정": "Edit Notice",
  "공지 작성/관리": "Notice Creation/Management",
  "공지 제목": "Notice Title",
  "공지가 없어. 위에서 새로 작성해줘.": "No notices. Create a new one above.",
  "관리": "Manage",
  "관리 상태": "Admin Status",
  "관리자 자산 표시 영역": "Admin asset summary area",
  "광고 관리": "Ad Management",
  "광고 목록 불러오는 중...": "Loading ad list...",
  "광고 목록을 불러오지 못했어.": "Failed to load ad list.",
  "광고 삭제에 실패했어.": "Failed to delete ad.",
  "광고 수정": "Edit Ad",
  "광고 이미지": "Ad Image",
  "광고 이미지 등록/관리": "Ad Image Registration/Management",
  "광고 이미지를 업로드해줘.": "Upload an ad image.",
  "광고 저장에 실패했어.": "Failed to save ad.",
  "국가(country)를 입력해줘. 예: KR / US / JP / ALL": "Enter country. Example: KR / US / JP / ALL",
  "굵기": "Weight",
  "그룹 노출(DisplaySet)": "Group Exposure (DisplaySet)",
  "그룹 미션": "Group Mission",
  "그룹 미션 설정": "Group Mission Settings",
  "그룹 미션 시작": "Start Group Mission",
  "그룹 미션 중지 실패 (백엔드에 DELETE /admin/mission/run/:run_id 필요)": "Failed to stop group mission (backend needs DELETE /admin/mission/run/:run_id)",
  "그룹 생성": "Create Group",
  "그룹 시간 설정이 올바르지 않습니다.": "Group time settings are invalid.",
  "그룹 이름": "Group Name",
  "그룹 이름, Small Blind, Big Blind는 필수 입력입니다. SB/BB는 예: 0.25, 0.50처럼 입력할 수 있습니다.": "Group name, Small Blind, and Big Blind are required. SB/BB can be entered like 0.25, 0.50.",
  "그룹명": "Group Name",
  "글로벌": "Global",
  "금액": "Amount",
  "금액은 최소 50$ 이상 부터 가능합니다.": "The amount must be at least $50.",
  "기간": "Period",
  "나의 지갑 주소": "My Wallet Address",
  "남미": "South America",
  "내 계정과 직·간접 하위(에이전트/유저)의 자산 이동 기록입니다. 필터를 적용해 검색할 수 있어요.": "Asset transfer history for my account and direct/indirect sub-accounts (agents/users). You can search using filters.",
  "내 어카운트": "My Account",
  "내 자산 0,000,000": "My Asset 0,000,000",
  "내부용 이름(label)": "Internal Name (label)",
  "내부용 이름(label)을 입력해줘.": "Enter the internal name (label).",
  "내용(message)": "Content (message)",
  "노출": "Visible",
  "노출(즉시/기간무관)": "Visible (Immediate / no period limit)",
  "노출중": "Visible",
  "닉네임": "Nickname",
  "다음": "Next",
  "닫기": "Close",
  "데이터 없음": "No data",
  "데이터가 없습니다.": "No data available.",
  "동남아": "Southeast Asia",
  "동아시아": "East Asia",
  "등록": "Register",
  "등록된 결제 옵션이 없습니다.": "No payment options registered.",
  "등록된 광고가 없어.": "No registered ads.",
  "등록된 라운지 글이 없습니다.": "No lounge posts registered.",
  "등록된 이미지 없음": "No registered image",
  "라운지 관리": "Lounge Management",
  "라운지 글": "Lounge Post",
  "라운지 글 목록": "Lounge Post List",
  "라운지 목록 불러오는 중...": "Loading lounge list...",
  "라운지 목록을 불러오지 못했습니다.": "Failed to load lounge list.",
  "라운지 상세에서 항목별 수량 입력 + 결제 버튼으로 표시됩니다.": "Shown in lounge details as item quantity input + payment button.",
  "라운지 아이템": "Lounge Item",
  "라운지 업로드": "Lounge Upload",
  "라운지 포인트 %": "Lounge Point %",
  "라운지 포인트 % (0~100)": "Lounge Point % (0–100)",
  "라운지 포인트 %는 0~100 사이 숫자이며 소수점은 최대 2자리까지 가능합니다.": "Lounge Point % must be a number between 0 and 100, up to 2 decimal places.",
  "라운지 포인트 지급률": "Lounge Point Reward Rate",
  "라운지 포인트 지급률 저장 실패": "Failed to save lounge point reward rate",
  "라운지포인트": "Lounge Points",
  "레이크백": "Rakeback",
  "로그아웃": "Logout",
  "로그인": "Login",
  "로그인 실패: ": "Login failed: ",
  "로딩 중...": "Loading...",
  "로딩중...": "Loading...",
  "를 색상별로 누적 표시)": "by color)",
  "링크 열기": "Open Link",
  "링크:": "Link:",
  "링크는 http:// 또는 https:// 로 시작해야 해.": "The link must start with http:// or https://.",
  "만료": "Expired",
  "만료일:": "Expires At:",
  "메모": "Memo",
  "메인 영역": "Main Area",
  "명": "users",
  "무한(30일 갱신)": "Infinite (30-day renewal)",
  "무한(infinite) 항목(상시 노출)": "Infinite items (always visible)",
  "미결제": "Unpaid",
  "미리보기": "Preview",
  "미션 RUN 생성 실패": "Failed to create mission RUN",
  "미션 cfg 저장 실패": "Failed to save mission cfg",
  "미션 상금 분배(프론트 계산)": "Mission Prize Distribution (front-end calculation)",
  "미션 상태 조회 실패": "Failed to load mission status",
  "미션 총 베팅금(target_total_bet)을 입력": "Enter mission total bet (target_total_bet)",
  "미입력시 자동": "Auto if empty",
  "받는 지갑": "Receiving Wallet",
  "받는쪽 (to)": "Receiver (to)",
  "발생시각": "Occurred At",
  "배경 색상": "Background Color",
  "배경 이미지 URL": "Background Image URL",
  "배경 타입": "Background Type",
  "백엔드에 종료 API가 있어야 실제 중지됨": "Actual stop requires a backend stop API.",
  "보내는 지갑": "Sending Wallet",
  "보낸쪽 (from)": "Sender (from)",
  "복사": "Copy",
  "복사 실패(브라우저 권한 확인)": "Copy failed (check browser permissions)",
  "본문": "Body",
  "본문 내용을 입력하세요": "Enter body content",
  "본문 블록": "Body Blocks",
  "본문을 입력해줘.": "Enter the body.",
  "북미": "North America",
  "분배 비율": "Distribution Rate",
  "분배 비율(상대 %)": "Distribution Rate (Relative %)",
  "불러오기 실패": "Failed to load",
  "불러오는 중…": "Loading…",
  "비밀번호": "Password",
  "비밀번호(미입력 시 변경 안 함)": "Password (leave blank to keep unchanged)",
  "비워두면 클릭 이동 없음": "Leave empty for no click-through link",
  "비활성": "Disabled",
  "사고 예방을 위해 다시한번 시작 후 하시는 것을 추천 합니다.": "To prevent mistakes, we recommend starting again before proceeding.",
  "삭제": "Delete",
  "삭제 실패": "Delete failed",
  "삭제됨": "Deleted",
  "상단 고정(📌)": "Pin to Top (📌)",
  "상세": "Details",
  "상시": "Always",
  "상위 에이전트:": "Parent Agent:",
  "상위 에이전트의 수수료(": "Parent agent fee (",
  "상태": "Status",
  "상태 보기 (테이블 미션 raw)": "View Status (table mission raw)",
  "새 공지 작성": "Create New Notice",
  "새 광고 등록": "Create New Ad",
  "새 전광판 등록": "Create New Marquee",
  "새로고침": "Refresh",
  "색상": "Color",
  "생성": "Create",
  "생성 (미체크 시 일반 유저 생성)": "Create (unchecked = normal user)",
  "생성 실패: ": "Create failed: ",
  "생성 에러:": "Create error:",
  "생성 중...": "Creating...",
  "생성 중…": "Creating…",
  "서버 오류": "Server error",
  "서버로 전송될 preset 문자열(콤마 구분)": "Preset string to send to server (comma-separated)",
  "선택 입력": "Optional Input",
  "세컨드 비밀번호(옵션)": "Secondary Password (Optional)",
  "소속 유저": "Assigned Users",
  "송금 시도하는 지갑 주소 와 다를시 돈을 잃을 수 있습니다. 꼭 다시 한번 확인 후 신청 부탁 드립니다.": "If this differs from the wallet address used for transfer, funds may be lost. Please check again before submitting.",
  "송금 완료 후 해당 버튼을 눌러주세요.": "Press this button after completing the transfer.",
  "수량": "Quantity",
  "수수료": "Fee",
  "수수료 수정": "Edit Fee",
  "수수료 수정 실패": "Failed to edit fee",
  "수정": "Edit",
  "수정 모드": "Edit Mode",
  "수정(설정)": "Edit (Settings)",
  "시간 설정": "Time Settings",
  "시간 설정이 올바르지 않습니다.": "Time settings are invalid.",
  "시작": "Start",
  "시작(로컬)": "Start (Local)",
  "시작(생성)": "Start (Create)",
  "시작일": "Start Date",
  "신규 작성": "New Draft",
  "썸네일 이미지": "Thumbnail Image",
  "아래로": "Down",
  "아이콘 업로드 실패 (서버 업로드 API 확인 필요)": "Icon upload failed (check server upload API)",
  "아이콘 파일은 1MB 이하로 올려주세요.": "Icon file must be 1MB or smaller.",
  "아이콘(로컬 업로드/URL)": "Icon (Local Upload/URL)",
  "아프리카": "Africa",
  "언어": "Language",
  "업로드": "Upload",
  "업로드 URL을 받지 못했습니다.": "Upload URL was not received.",
  "업로드 URL을 받지 못했어.": "Upload URL was not received.",
  "업로드 비용": "Upload Fee",
  "업로드/게시": "Upload/Publish",
  "업로드중...": "Uploading...",
  "업로드하면 /uploads/... 로 자동 입력됨 (또는 URL 직접 입력)": "After upload, /uploads/... is auto-filled (or enter URL directly).",
  "에이전트": "Agent",
  "에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "Enter agent distribution rate (agent_share) (e.g., 0.2 = 20%)",
  "에이전트 상금풀(": "Agent prize pool (",
  "에이전트 차단/해제 API 연결이 필요합니다.\n(현재는 사용자 차단만 지원 중)": "Agent block/unblock API connection is required.\n(Currently only user blocking is supported.)",
  "에이전트로 생성": "Create as Agent",
  "예: 25": "e.g., 25",
  "예: AGT3001 또는 user123": "e.g., AGT3001 or user123",
  "예: HOT": "e.g., HOT",
  "예: KR / US / JP / ALL": "e.g., KR / US / JP / ALL",
  "예: NEW YEAR EVENT START!": "e.g., NEW YEAR EVENT START!",
  "예: VIP NLH 1/2": "e.g., VIP NLH 1/2",
  "예: 메인 KR 모바일 상단 배너": "e.g., Main KR mobile top banner",
  "예: 오늘만 레이크 0%": "e.g., 0% rake today only",
  "예: 🔥 12/31 이벤트 진행중": "e.g., 🔥 12/31 event is live",
  "예: 🔧HOT": "e.g., 🔧HOT",
  "예약": "Scheduled",
  "예약 tick": "Schedule Tick",
  "예약 보류": "Pending Schedule",
  "예약 사용": "Use Schedule",
  "예약 상태면 startAt(시작일시)를 넣어줘.": "If status is scheduled, enter startAt.",
  "예약 시간이 올바르지 않습니다.": "Scheduled time is invalid.",
  "예약 없음": "No Schedule",
  "예약 없음 → 즉시 진행(running)으로 자동 설정됨": "No schedule → automatically set to running immediately.",
  "예약(reserve_time_utc)": "Schedule (reserve_time_utc)",
  "예약/상태": "Schedule/Status",
  "예약보류": "Schedule Pending",
  "오래된순": "Oldest First",
  "왼쪽에서 공지를 선택해줘.": "Select a notice on the left.",
  "왼쪽에서 광고를 선택해줘.": "Select an ad on the left.",
  "요소(최대 4개)": "Elements (max 4)",
  "용량": "Size",
  "위로": "Up",
  "유럽": "Europe",
  "유저 관리": "User Management",
  "유저코드": "User Code",
  "유효 인포메이션 버튼:": "Valid Information Buttons:",
  "을 눌러야 서버에 반영됨": " must be pressed to apply to the server.",
  "이 노드의 기본 수수료 비율(%)": "Default fee rate (%) for this node",
  "이 에이전트 밑 모든 플레이어 수수료를 한 번에 설정": "Set all player fees under this agent at once",
  "이 페이지에 접근할 수 있는 권한이 없습니다.": "You do not have permission to access this page.",
  "이동 URL": "Target URL",
  "이미지": "Image",
  "이미지 URL": "Image URL",
  "이미지 alt 텍스트": "Image alt text",
  "이미지 넣기": "Insert Image",
  "이미지 블록": "Image Block",
  "이미지 업로드 중...": "Uploading image...",
  "이미지 업로드에 실패했습니다.": "Image upload failed.",
  "이미지 업로드중...": "Uploading image...",
  "이미지 없음": "No image",
  "이미지 열기": "Open Image",
  "이미지 파일만 등록할 수 있어.": "Only image files can be registered.",
  "이미지 파일만 업로드할 수 있어.": "Only image files can be uploaded.",
  "이미지(URL)": "Image (URL)",
  "이미지는 5MB 이하만 업로드할 수 있어.": "Images must be 5MB or smaller.",
  "이미지는 본문 안에 [image-번호] 형태로 표시됨.": "Images are displayed in the body as [image-number].",
  "이전": "Previous",
  "인포 버튼 시간 설정이 올바르지 않습니다.": "Info button time settings are invalid.",
  "인포 버튼 프리셋 수정": "Edit Info Button Preset",
  "인포 버튼 프리셋 수정 실패": "Failed to edit info button preset",
  "인포메이션 버튼(선택)": "Information Button (Optional)",
  "인포버튼 없음": "No Info Button",
  "인포버튼 프리셋 수정": "Edit Info Button Preset",
  "인포버튼 프리셋 수정 실패": "Failed to edit info button preset",
  "인포카드 추가": "Add Info Card",
  "인포카드 추가 실패": "Failed to add info card",
  "인포카드 타이머": "Info Card Timer",
  "일": "days",
  "일 /": "days /",
  "일/": "days/",
  "일반 자산": "Main Asset",
  "임시": "Draft",
  "임시저장": "Draft",
  "입력값을 확인해 주세요.": "Please check the input values.",
  "자산": "Asset",
  "자산 으로 변환": "Convert to Asset",
  "자산 타입": "Asset Type",
  "자산기록": "Asset Ledger",
  "작성": "Create",
  "작성일:": "Created At:",
  "작성자": "Writer",
  "잠금 비밀번호": "Lock Password",
  "재게시": "Republish",
  "재시작": "Restart",
  "저장": "Save",
  "저장 시 실제 이미지 URL 토큰으로 자동 변환됨.": "On save, it is automatically converted to the actual image URL token.",
  "저장 중...": "Saving...",
  "저장됩니다. 기준 시간은 위 인포카드 타이머 설정(timerMode/timerEndUtc)을 사용합니다.": "Saved. The reference time uses the info card timer settings above (timerMode/timerEndUtc).",
  "저장은 무료, 최초 게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "Saving is free; the cost is deducted from the agent asset only on first publish.",
  "저장은 무료입니다. 최초 업로드/게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "Saving is free. The cost is deducted from the agent asset only on first upload/publish.",
  "저장중...": "Saving...",
  "적용": "Apply",
  "전광판": "Marquee",
  "전광판 관리": "Marquee Management",
  "전광판 등록 실패": "Failed to create marquee",
  "전광판 목록 조회 실패": "Failed to load marquee list",
  "전광판 삭제 실패": "Failed to delete marquee",
  "전광판 수정 실패": "Failed to edit marquee",
  "전체": "All",
  "전체 상태": "Overall Status",
  "접기": "Collapse",
  "정렬": "Sort",
  "정렬 변경에 실패했어.": "Failed to change order.",
  "정렬 저장": "Save Order",
  "정렬 저장 실패": "Failed to save order",
  "정렬 화살표는 같은 area/device/country 묶음 안에서만 동작해.": "Sort arrows only work inside the same area/device/country group.",
  "정보 수정 실패": "Failed to edit information",
  "정보수정": "Edit Info",
  "정상": "Normal",
  "제거": "Remove",
  "제목": "Title",
  "제목을 입력하세요": "Enter a title",
  "제목을 입력해줘.": "Enter a title.",
  "조회": "Search",
  "종료(로컬)": "End (Local)",
  "종료일": "End Date",
  "줄바꿈 그대로 표시됨.": "Line breaks are preserved.",
  "중동": "Middle East",
  "중앙아시아": "Central Asia",
  "중지": "Stop",
  "중지(삭제)": "Stop (Delete)",
  "중지됨": "Stopped",
  "지갑 주소": "Wallet Address",
  "지금": "Now",
  "지급": "Credit",
  "지급 실패": "Credit failed",
  "차감": "Debit",
  "차감 실패": "Debit failed",
  "차단": "Block",
  "차단 해제": "Unblock",
  "차단됨": "Blocked",
  "처리 중...": "Processing...",
  "체크하지 않으면 앞으로 새로 생성되는 테이블에만 적용됩니다.": "If unchecked, this applies only to newly created tables going forward.",
  "초기화": "Reset",
  "초안": "Draft",
  "총": "Total",
  "총 상금풀(1.5%):": "Total prize pool (1.5%):",
  "총베팅액:": "Total Bet:",
  "최근순": "Newest First",
  "추가": "Add",
  "출금하기": "Withdraw",
  "충전 하기": "Deposit",
  "취소": "Cancel",
  "카테고리": "Category",
  "크기(px)": "Size (px)",
  "클릭 시 출금이 시작 됩니다.": "Withdrawal starts when clicked.",
  "클릭 이동 URL(link_url)": "Click-through URL (link_url)",
  "클릭 이동 링크(URL)": "Click-through Link (URL)",
  "클릭하면 등록 모달": "Click to open registration modal",
  "클릭하면 표시 기준 시간이 해당 날짜로 설정됩니다": "Click to set the display reference time to this date.",
  "클릭하여 이미지 업로드": "Click to upload image",
  "타이머 없음": "No Timer",
  "타이머 타입": "Timer Type",
  "타이머(존재유무만)": "Timer (existence only)",
  "타이머는": "Timer is",
  "타입": "Type",
  "테스트 거래는 0.01USDT 를 송금 하여 올바른 입금이 되었는지 확인 후 시작 하는 거래 입니다.": "A test transaction sends 0.01 USDT to confirm the deposit is correct before starting.",
  "테이블 관리": "Table Management",
  "테이블 그룹 목록 조회 실패": "Failed to load table group list",
  "테이블 그룹 생성 실패": "Failed to create table group",
  "테이블 그룹 생성 완료": "Table group created successfully",
  "테이블 그룹 코드 생성 실패": "Failed to generate table group code",
  "테이블 그룹이 없습니다.": "No table groups.",
  "테이블 미션": "Table Mission",
  "테이블 미션 RUN 생성 실패": "Failed to create table mission RUN",
  "테이블 미션 RUN 중지 실패": "Failed to stop table mission RUN",
  "테이블 미션 cfg 저장 실패": "Failed to save table mission cfg",
  "테이블 미션 상금 분배(프론트 계산)": "Table mission prize distribution (front-end calculation)",
  "테이블 미션 상태 조회 실패": "Failed to load table mission status",
  "테이블 미션 에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "Enter table mission agent distribution rate (agent_share) (e.g., 0.2 = 20%)",
  "테이블 미션 총 베팅금(target_total_bet)을 입력": "Enter table mission total bet (target_total_bet)",
  "텍스트": "Text",
  "텍스트 블록": "Text Block",
  "텍스트 스타일": "Text Style",
  "파일명": "File Name",
  "판매": "Sold",
  "페이지": "Page",
  "페이지 크기": "Page Size",
  "펼치기": "Expand",
  "폰트스타일": "Font Style",
  "폴더에 저장되고, DB에는 메타/경로만 저장돼.": "folder, and only metadata/path is stored in DB.",
  "표시 기준 시간": "Display Reference Time",
  "표시 순서(order)": "Display Order (order)",
  "표시 여부만": "Visibility only",
  "표시명": "Display Name",
  "표시할 기록이 없습니다.": "No records to display.",
  "프론트 테스트: 송금 완료 처리(백엔드 연결 전)": "Front test: transfer complete processing (before backend connection)",
  "프론트 테스트: 출금 시작 처리(백엔드 연결 전)": "Front test: withdrawal start processing (before backend connection)",
  "프리셋 수정": "Edit Preset",
  "프리셋(배경/요소/URL)": "Preset (Background/Elements/URL)",
  "플레이어 상금풀(": "Player prize pool (",
  "플레이어 수수료 설정": "Player Fee Settings",
  "하위": "Child",
  "하위 계정 생성": "Create Child Account",
  "하위 생성": "Create Child",
  "하위 생성 (부모:": "Create Child (Parent:",
  "하이라이트 메세지": "Highlight Message",
  "하이라이트 포인트": "Highlight Point",
  "해당 문제의 금액에 관해서는 책임이 불가하오니 반드시 다시 확인 해주 시길 바랍니다.": "We cannot be responsible for funds affected by this issue. Please double-check before proceeding.",
  "현재 index 값들을 서버에 저장": "Save current index values to the server",
  "현재 라운지 포인트 %": "Current Lounge Point %",
  "현재 활성 테이블에도 즉시 적용": "Apply immediately to currently active tables as well",
  "확인용 테스트 거래 시작": "Start Test Transaction",
  "활성 RUN이 없습니다.": "No active RUN.",
  "회원 정보 수정": "Edit Member Info",
  "🔐 어드민 로그인": "🔐 Admin Login",
  "요청 실패 ({status})": "Request failed ({status})",
  "지급 (대상: {targetId})": "Credit (Target: {targetId})",
  "차감 (대상: {targetId})": "Debit (Target: {targetId})",
  "본인 {id}": "Self {id}",
  "하위 {id}": "Child {id}",
  "테이블 그룹 삭제?\n({displayCode})": "Delete table group?\n({displayCode})",
  "그룹은 삭제됐지만 Redis 정리가 실패했습니다. (code={code})": "Group was deleted, but Redis cleanup failed. (code={code})",
  "그룹 미션 RUN 중지?\nrun_id={runId}": "Stop group mission RUN?\nrun_id={runId}",
  "이미 테이블 미션 RUN이 실행 중입니다.\n(run_id={runId})\n재시작(기존 RUN 삭제 후 새로 생성)할까요?": "A table mission RUN is already running.\n(run_id={runId})\nRestart it (delete existing RUN and create a new one)?",
  "테이블 미션 RUN 중지(그룹 전체 적용)?\n(display_code={displayCode})": "Stop table mission RUN (applies to entire group)?\n(display_code={displayCode})",
  "무한(약 {days}일 단위 갱신)": "Infinite (renews about every {days} days)",
  "업로드 비용 {fee} USDT가 UserDB.asset에서 차감되고, 결제일 기준 {days}일 동안 게시됩니다. 게시할까요?": "Upload fee {fee} USDT will be deducted from UserDB.asset and published for {days} days from the payment date. Publish now?",
  "전광판 삭제?\n(id={id})": "Delete marquee?\n(id={id})",
  "이미지 업로드 실패: {message}": "Image upload failed: {message}",
  "광고를 삭제할까?\n\n- {label}": "Delete this ad?\n\n- {label}",
  "{targetId} 삭제하시겠습니까?": "Delete {targetId}?",
  "라운지 저장에 실패했습니다.\n{message}": "Failed to save lounge.\n{message}",
  "라운지 게시에 실패했습니다.\n{message}": "Failed to publish lounge.\n{message}",
  "이 라운지 글을 중지할까요?\n\n- {title}": "Stop this lounge post?\n\n- {title}",
  "라운지 중지에 실패했습니다.\n{message}": "Failed to stop lounge post.\n{message}",
  "이 라운지 글을 삭제 처리할까요?\n\n- {title}": "Mark this lounge post as deleted?\n\n- {title}",
  "라운지 삭제에 실패했습니다.\n{message}": "Failed to delete lounge post.\n{message}",
  "공지 목록을 불러오지 못했어.\n{message}": "Failed to load notice list.\n{message}",
  "공지 저장에 실패했어.\n{message}": "Failed to save notice.\n{message}",
  "공지 삭제할까?\n\n- {title}": "Delete this notice?\n\n- {title}",
  "공지 삭제에 실패했어.\n{message}": "Failed to delete notice.\n{message}",
  "인포카드": "Info Card",
  "인포카드 삭제": "Delete Info Card",
  "인포카드 삭제 실패": "Failed to delete info card",
  "이 인포카드를 삭제하시겠습니까? 같은 카드의 데스크톱/모바일·언어별 변형도 함께 삭제됩니다. 테이블 그룹과 게임 테이블은 삭제되지 않습니다.": "Delete this info card? All desktop/mobile and language variants of the same card will also be deleted. The table group and game tables will not be deleted."
};

export default en;
